const oidc = {
    logout_success: 'Ha cerrado sesión con éxito.',
};
export default oidc;
